import React from "react";

import { Store, Dispatcher, Constants } from "../../../flux";

class NavbarToggle extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      menuVisible: Store.getMenuState(),
    };
    this.onChange = this.onChange.bind(this);
    this.handleClick = this.handleClick.bind(this);
  }

  componentWillMount() {
    Store.addChangeListener(this.onChange);
  }

  componentWillUnmount() {
    Store.removeChangeListener(this.onChange);
  }

  async onChange() {
    this.setState({
      ...this.state,
      menuVisible: Store.getMenuState(),
    });
  }

  handleClick() {
    Dispatcher.dispatch({
      actionType: Constants.TOGGLE_SIDEBAR,
    });
  }

  render() {
    const toggle_class = this.state.menuVisible ? "sidebar-open" : "sidebar-close";

    return (
      <nav className="nav">
        {/* eslint-disable-next-line jsx-a11y/anchor-is-valid */}
        <a
          href="#"
          onClick={this.handleClick}
          className={`nav-link nav-link-icon toggle-sidebar d-sm-inline d-md-inline d-lg-none text-center ${toggle_class}`}
        >
          <i className="material-icons">&#xE5D2;</i>
        </a>
      </nav>
    );
  }
}

export default NavbarToggle;
